import { render } from "./ReviewCycleDetails.vue?vue&type=template&id=66edda24&scoped=true"
import script from "./ReviewCycleDetails.vue?vue&type=script&lang=js"
export * from "./ReviewCycleDetails.vue?vue&type=script&lang=js"

import "./ReviewCycleDetails.vue?vue&type=style&index=0&id=66edda24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66edda24"]])

export default __exports__